import api from '@/api/tecnologico.api'

let servicio = {}

servicio.apartadosMenuCon = (idSistema) => {
    return api.get(`/apartadosmenu/apartadosmenucon/${idSistema}`)
}

export default servicio
